/* eslint-disable react/no-array-index-key */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './index.scss';
import 'react-loading-skeleton/dist/skeleton.css';

import { QueryClient } from '@tanstack/react-query';
import AppProvider from 'components/common/AppProvider';
import Notifications from 'components/common/notification/Notifications';
import NOTIFICATIONS from 'constants/notification';
import Loading from 'design-system/Loading/Loading';
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import SERVICE_CONFIG from 'services/tq-adapter/tqConfig';
import store from 'store';

const Routing = lazy(() => import('./Routing'));

const queryClient = new QueryClient(SERVICE_CONFIG());
const notifications = Object.values(NOTIFICATIONS);

type RootProps = { store: typeof store };

const Root = ({ store: storeProp }: RootProps) => (
  <AppProvider store={storeProp} queryClient={queryClient}>
    <Notifications notifications={notifications} />
    <Suspense fallback={<Loading />}>
      <Routing />
    </Suspense>
  </AppProvider>
);

const RootWithRedux = Root;

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MOCK_API === 'true') {
  // eslint-disable-next-line global-require
  const { worker } = require('./mocks/browser');
  worker.start();
}

createRoot(document.getElementById('root')!).render(<RootWithRedux store={store} />);
